/* eslint-disable max-lines */
import _ from 'underscore';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';

export const OdataType = '@odata.type';
export const OneDayMs = 86400000;
export const tileColumnWidth = 520;
export const DefaultCountryCode = 'US';
export const DefaultCurrencyCode = 'USD';
export const DefaultTimeZoneCode = '71'; // Paficifc Time US
export const DefaultLanguage = 'en-us';
export const TOKEN_EXPIRED = 'TokenExpired';
export const UNKNOWN_USER = 'Unknown User';
export const CUSTOMER_NAME_MAX_LENGTH = 90;
export const EXTERNAL_API_TIMEOUT = 5000;
export const ENTIRE_TIME_CAMPAIGN_OFFSET_NEWEST_DAY = -30; // 30 days
export const ENTIRE_TIME_CAMPAIGN_OFFSET_OLDEST_YEAR = -3; // 3 years
export const ENTIRE_TIME_SOCIAL_OFFSET_NEWEST_DAY = -30; // 30 days
export const ENTIRE_TIME_SOCIAL_OFFSET_OLDEST_DAY = -180; // 180 days
export const TEMP_NAME_PREFIX = '_DMC_TEMP_';
export const UP_TEMP_NAME_PREFIX = '_UP_TEMP_';
export const ACCOUNT_BUDGET_EXCEED_CODE = 'ExceedDailyBudgetLimit';
export const ACCOUNT_ENTITY = 'Account';
export const ACCOUNT_ACTIVATION_FIELD = 'AccountActivationField';
export const USER_ENTITY = 'User';
export const USER_UPDATE_FIELD = 'UserUpdateField';
export const SUPPORT_WEBSITE = 'https://about.ads.microsoft.com/en-us/microsoft-advertising-support';
export const A11yAnnounceAreaId = 'a11yAnnounceArea';
export const ALL_CAMPAIGNS_PATH = '/campaign/mca/ads/all-campaigns';
export const SINGLE_CAMPAIGN_PATH = '/campaign/mca/ads/campaign/';
export const GOOGLE_IMPORT_PATH = '/campaign/vnext/googleimport';
export const IMPORT_SCHEDULE_PATH = '/campaign/vnext/importschedule';
export const LIVE_CHAT_ELEMENT_ID = 'msSupportChatTrigger';
export const UP_SUPPORT_CHAT_LINK = 'https://vsa.services.microsoft.com/en-us/v1.0/?product=bingads&issue=Ads-Experiment&disability=false&mode=live&partnerId=a1689b11-62c0-4f31-be04-05982f92b619&modality=occhat&flowId=Showcase-Exp&queue=/chat/122';
export const MAX_KEYWORD_COUNT = 50;
export const MAX_CAMPAIGN_COUNT = 100;

export const PAYMENT_TYPE_POSTPAY = Constants.PaymentTypeId.Postpay;
export const PAYMENT_TYPE_PREPAY = Constants.PaymentTypeId.Prepay;
export const PAYMENT_TYPE_UNDEFINED = Constants.PaymentTypeId.Undefined;
export const PAYMENT_OPTION_THRESHOLD = Constants.PaymentOption.Threshold;
export const PAYMENT_OPTION_PREPAY = Constants.PaymentOption.Prepay;
export const PI_TYPE_CREDIT_CARD = Constants.PaymentInstrumentType.CreditCard;
export const PI_TYPE_PAYPAL = Constants.PaymentInstrumentType.PayPal;
export const PI_TYPE_OFFLINE_PAYMENT_METHOD = Constants.PaymentInstrumentType.OfflinePaymentMethod;

export const MAX_M365_STANDARD_SCHEDULED_POSTS_COUNT = 10;
export const MAX_ARIA_MESSAGE_DETAILS_SIZE = 200;

// eslint-disable-next-line no-useless-escape
export const INT_PHONE_REGEX = /^(\+0?\d{1,3})?((\s|\(|\))*\-*\d){8,10}$/;

export const PostLimits = {
  fb: 5000,
  twitter: 280,
  ig: 2200,
  linkedin: 1300,
};

export const CreditCardStatus = {
  primary: 'primary',
  backup: 'backup',
  additional: 'additional',
};

export const FlowIds = {
  DmcMain: 'DMC-main',
  DmcSignUp: 'DMC-signup',
  M365AdminSignUp: 'm365-admin-campaign',
  M365RmSignUp: 'm365-rm-campaign',
  SubAdsMain: 'Subscription-ads-main',
  SubAdsSignUp: 'Subscription-ads-signup',
  UpMain: 'UP-main',
  UpSignUp: 'UP-signup-up',
  UpSignUpExpert: 'UP-signup-expert',
};

export const onErrorRetryLimit = 3;

// Channel Types
export const McaChannelTypes = {
  Undefined: 'Undefined',
  Internal: 'Internal',
  Facebook: 'Facebook',
  Instagram: 'Instagram',
  Twitter: 'Twitter',
  LinkedIn: 'LinkedIn',
  MicrosoftAdvertising: 'MicrosoftAdvertising',
  GoogleAds: 'GoogleAds',
  GoogleMyBusiness: 'GoogleMyBusiness',
  BingPlaces: 'BingPlaces',
  MSAN: 'MSAN',
};

// Obtained from MT /private/MultiChannelAds/Common/DgoLib/EntityFactories/BudgetFactory.cs
export const McaChannelTypeBudgetRatio = {
  [McaChannelTypes.MicrosoftAdvertising]: 1,
  [McaChannelTypes.GoogleAds]: 3,
  [McaChannelTypes.Facebook]: 2,
  [McaChannelTypes.MSAN]: 1,
};

export const McaSocialChannelTypes = [
  McaChannelTypes.Facebook,
  McaChannelTypes.Instagram,
  McaChannelTypes.LinkedIn,
  McaChannelTypes.Twitter,
];

export const McaChannelTypeToPlatformName = {
  [McaChannelTypes.GoogleAds]: 'Google',
  [McaChannelTypes.MicrosoftAdvertising]: 'Bing',
  [McaChannelTypes.Facebook]: 'Facebook',
  [McaChannelTypes.MSAN]: 'Microsoft',
};

export const PlatformTypesSize = 3;

export const PlatformTypes = {
  audience: new Set([McaChannelTypes.MSAN]),
  social: new Set([McaChannelTypes.Facebook]),
  search: new Set([McaChannelTypes.GoogleAds, McaChannelTypes.MicrosoftAdvertising]),
};

export const McaChannelTypeToServingPlatform = {
  [McaChannelTypes.GoogleAds]: _TL_('Google'),
  [McaChannelTypes.MicrosoftAdvertising]: _TL_('Microsoft Search Network'),
  [McaChannelTypes.Facebook]: _TL_('Facebook, Instagram'),
  [McaChannelTypes.MSAN]: _TL_('Microsoft Audience Network'),
};

export const McaTargetModel = {
  LocationTarget: '#Model.LocationTarget',
  RadiusTarget: '#Model.RadiusTarget',
  AgeTarget: '#Model.AgeTarget',
  GenderTarget: '#Model.GenderTarget',
};

export const McaAgeTargets = {
  EighteenToTwentyFour: 'EighteenToTwentyFour',
  TwentyFiveToThirtyFour: 'TwentyFiveToThirtyFour',
  ThirtyFiveToFortyNine: 'ThirtyFiveToFourtyNine',
  FiftyToSixtyFour: 'FiftyToSixtyFour',
  SixtyFiveAndAbove: 'SixtyFiveAndAbove',
  Unknown: 'Unknown',
};

export const McaDefaultAgeTargets = [
  McaAgeTargets.EighteenToTwentyFour,
  McaAgeTargets.TwentyFiveToThirtyFour,
  McaAgeTargets.ThirtyFiveToFortyNine,
  McaAgeTargets.FiftyToSixtyFour,
  McaAgeTargets.SixtyFiveAndAbove,
  McaAgeTargets.Unknown,
];

export const McaGenderTargets = {
  Female: 'Female',
  Male: 'Male',
  Unknown: 'Unknown',
};

export const McaDefaultGenderTargets = [
  McaGenderTargets.Male,
  McaGenderTargets.Female,
  McaGenderTargets.Unknown,
];

export const CriterionModel = {
  RadiusCriterion: '#Model.RadiusCriterion',
  LocationCriterion: '#Model.LocationCriterion',
};

export const Location2Type = {
  Country: 'Country',
  SubGeography: 'SubGeography',
  MetroArea: 'MetroArea',
  City: 'City',
  PostalCode: 'PostalCode',
  County: 'County',
  Neighborhood: 'Neighborhood',
};

export const McaRadiusUnit = {
  Miles: 'Miles',
  Kilometers: 'Kilometers',
};

export const DistanceUnit = {
  Miles: 'Miles',
  Kilometers: 'Kilometers',
};

export const McaChannelIds = {
  Undefined: 0,
  Internal: 1,
  Facebook: 2,
  Instagram: 3,
  Twitter: 4,
  GoogleMyBusiness: 7,
  BingPlaces: 8,
  LinkedIn: 9,
};

// Microsoft.Ads.TemplateAdSubstitution.TemplateAdType
export const TemplateAdType = {
  ExpandedTextAds: 'ExpandedTextAds',
  FaceBook: 'FaceBook',
  ImageAds: 'ImageAds',
};

export const TestAccountPartitionSuffixes = [
  '_2EE8FF97-DCF0-4C9E-9EBE-CB05DFA435D4_110',
  '_2EE8FF97-DCF0-4C9E-9EBE-CB05DFA435D4_111',
];

export const ConversationThreadLoadPatterns = {
  ExpandToRoot: 'ExpandToRoot',
  ExpandToChildren: 'ExpandToChildren',
};

export const PROTOCOLS = {
  HTTP: 'http://',
  HTTPS: 'https://',
};

export const McaOdataInboxActivityTypes = [
  '#Model.FacebookWallPost',
  '#Model.FacebookComment',
  '#Model.FacebookAdComment',
  '#Model.FacebookReview',
  '#Model.InstagramComment',
  '#Model.InstagramAdComment',
  '#Model.TwitterMention',
  '#Model.TwitterRetweet',
  '#Model.TwitterRetweetWithComment',
  '#Model.TwitterNewFollower',
  '#Model.LinkedInComment',
];

// Odata Activity Types
export const McaOdataActivityTypes = [
  ...McaOdataInboxActivityTypes,
  '#Model.FacebookPost',
  '#Model.InstagramPost',
  '#Model.TwitterPost',
  '#Model.LinkedInShare',
  '#Model.GoogleMyBusinessReview',
  '#Model.GoogleMyBusinessQuestion',
  '#Model.BingPlacesReview',
];

// Activity Types
export const McaActivityTypes = [
  // Facebook
  'FacebookWallPost',
  'FacebookComment',
  'FacebookAdComment',
  'FacebookReview',
  'FacebookPost',
  // Instagram
  'InstagramComment',
  'InstagramAdComment',
  'InstagramPost',
  // Twitter
  'TwitterPost',
  'TwitterMention',
  'TwitterRetweet',
  'TwitterRetweetWithComment',
  'TwitterNewFollower',
  // Google My Business
  'GoogleMyBusinessReview',
  'GoogleMyBusinessQuestion',
  // Bing places
  'BingPlacesReview',
  // LinkedIn
  'LinkedInShare',
  'LinkedInComment',
];

// List of supported activity types in social inbox
export const McaInboxActivityTypes = {
  // Facebook
  FacebookWallPost: 'FacebookWallPost',
  FacebookComment: 'FacebookComment',
  FacebookAdComment: 'FacebookAdComment',
  FacebookReview: 'FacebookReview',
  // Instagram
  InstagramComment: 'InstagramComment',
  InstagramAdComment: 'InstagramAdComment',
  // Twitter
  TwitterMention: 'TwitterMention',
  TwitterRetweet: 'TwitterRetweet',
  TwitterRetweetWithComment: 'TwitterRetweetWithComment',
  TwitterNewFollower: 'TwitterNewFollower',
  // LinkedIn
  LinkedInComment: 'LinkedInComment',
};

export const McaChannelActivityTypes = {
  Facebook: [
    McaInboxActivityTypes.FacebookWallPost,
    McaInboxActivityTypes.FacebookComment,
    McaInboxActivityTypes.FacebookAdComment,
    McaInboxActivityTypes.FacebookReview,
  ],
  Instagram: [
    McaInboxActivityTypes.InstagramComment,
    McaInboxActivityTypes.InstagramAdComment,
  ],
  Twitter: [
    McaInboxActivityTypes.TwitterMention,
    McaInboxActivityTypes.TwitterRetweet,
    McaInboxActivityTypes.TwitterRetweetWithComment,
    McaInboxActivityTypes.TwitterNewFollower,
  ],
  LinkedIn: [
    McaInboxActivityTypes.LinkedInComment,
  ],
};

export const McaActivityLayoutTypes = [
  'InboxList',
  'InboxConversation',
  'PostPreview',
];

// ChannelUserTypes
export const McaChannelUserTypes = [
  'FacebookUser',
  'FacebookPage',
  'InstagramUser',
  'GoogleUser',
  'BingUser',
];

export const McaProfileStatus = {
  Draft: 1,
  Scheduled: 2,
  Active: 3,
  Deleted: 4,
};

export const MediaType = {
  Unknown: 'Unknown',
  Image: 'Image',
  Video: 'Video',
  Gif: 'Gif',
};

export const McaAccountTier = {
  None: 'None',
  M365PremiumAccountTier: 'M365PremiumAccountTier',
};

export const McaMediaTypes = [
  'noMedia',
  MediaType.Image,
  MediaType.Gif,
  MediaType.Video,
  'Share',
];

export const McaEditorialEntityTypes = {
  McaCampaign: 'McaCampaign',
  McaAd: 'McaAd',
  McaKeyword: 'McaKeyword',
};

export const McaEditorialTypes = {
  Inline: 'Inline',
  Offline: 'Offline',
};

export const McaEditorialAppealStatus = {
  UnKnown: 'UnKnown',
  Appealable: 'Appealable',
  AppealPending: 'AppealPending',
  NotAppealable: 'NotAppealable',
};

export const McaEditorialStatus = {
  UnKnown: 'UnKnown',
  Approved: 'Approved',
  ApprovedLimited: 'ApprovedLimited',
  Disapproved: 'Disapproved',
  Pending: 'Pending',
  UnderAppeal: 'UnderAppeal',
  Rejected: 'Rejected',
};

export const McaAppealStatus = {
  // ad status is approved or appeal is expired
  Unspecified: 'Unspecified',
  // ad status is disapproved, user has submitted appeal from UI
  Submitted: 'Submitted',
  // appeal request has been synced to current channelad or mcaad
  Synced: 'Synced',
  // appeal request sync is failed to current channelad or mcaad
  ErrorSyncing: 'ErrorSyncing',
};

export const McaCampaignGoals = {
  IncreaseWebsiteVisit: {
    value: 'IncreaseWebsiteVisit',
    title: _TL_('Get more visits to my website'),
    description: _TL_('Visits to my website. Choose this goal if: You want to drive traffic to your website. What you need to know: Setting your goal right at the start lets us suggest the most helpful Microsoft Advertising and Google Ads features for your campaign. You\'ll still have access to all Microsoft Advertising and Google Ads  features regardless of the goal you choose.'),
    topic: 'pop_DMC_Goals_MoreVisits',
  },
  IncreaseCallToBusiness: {
    value: 'IncreaseCallToBusiness',
    title: _TL_('Get more phone calls to my business'),
    description: _TL_('Phone calls to my business. Choose this goal if: You want to drive new phone calls to your business\'s phone number. What you need to know: Setting your goal right at the start lets us suggest the most helpful Microsoft Advertising and Google Ads features for your campaign. You\'ll still have access to all Microsoft Advertising and Google Ads features regardless of the goal you choose.'),
    topic: 'pop_DMC_Goals_MoreCalls',
  },
  IncreaseBusinessLocationVisit: {
    value: 'IncreaseBusinessLocationVisit',
    title: _TL_('Get more visits to my business\' physical location'),
    description: _TL_('Get more foot traffic. Choose this goal if: You want to get more people to visit your store or office. What you need to know: Setting your goal right at the start lets us suggest the most helpful Microsoft Advertising and Google Ads features for your campaign. You\'ll still have access to all Microsoft Advertising and Google Ads features regardless of the goal you choose.'),
    topic: 'pop_DMC_Goals_MoreFootTraffic',
  },
};

export const McaCampaignMode = {
  DMC: 'DMC',
  UP: 'UP',
};

export const McaCampaignStatus = {
  Active: 'Active',
  Deleted: 'Deleted',
  Paused: 'Paused',
  Draft: 'Draft',
};

// Check the unicode CLDR documentation for other
// date format skeletons
export const McaDateFormatType = [
  'MEd', // Tue, 11/30
  'MEdhm', // Tue, 11/30 2:33PM
  'MMMd', // May 30
  'MMMEEEEd', // Tuesday, Nov 30
  'yMMMd', // May 30, 2022
  'yMEdhm', // Tue, 11/30/2020 2:33PM
  'yMEd', // Tue, 11/30/2020
];

export const McaSocialChannels = {
  Facebook: {
    id: 'Facebook',
    name: _TL_('Facebook'),
    color: '#00188F',
  },
  Instagram: {
    id: 'Instagram',
    name: _TL_('Instagram'),
    color: '#E3008C',
  },
  Twitter: {
    id: 'Twitter',
    name: _TL_('Twitter'),
    color: '#4B003F',
  },
  LinkedIn: {
    id: 'LinkedIn',
    name: _TL_('LinkedIn'),
    color: '#00A2AD',
  },
};

export const McaTopMetricsSettings = {
  Impressions: {
    color: '#00188F',
    title: _TL_('Impressions'),
    help: 'pop_DMC_Campaigns_Impr',
  },
  Clicks: {
    color: '#E3008C',
    title: _TL_('Clicks'),
    help: 'pop_DMC_Campaigns_Clicks',
  },
  Spend: {
    color: '#4B003F',
    title: _TL_('Spend'),
  },
  Directions: {
    color: '#001D3F',
    title: _TL_('Direction Inquiries'),
    help: 'pop_DMC_Campaigns_DirectionInquiries',
  },
  Calls: {
    color: '#00A2AD',
    title: _TL_('Calls'),
    help: 'pop_DMC_Campaigns_Calls',
  },
  Engagements: {
    color: '#917EDB',
    title: _TL_('Engagements'),
    help: 'pop_DMC_Campaigns_Engagement',
  },
  Audiences: {
    color: '#E1DFDD',
    title: _TL_('Audience Growth'),
    showSign: true,
  },
  Conversions: {
    color: '#EF6950',
    title: _TL_('Conversions'),
    help: 'pop_DMC_Campaigns_Conversions',
  },
  Revenue: {
    color: '#0078D4',
    title: _TL_('Conversion Revenue'),
  },
};

export const PostState = {
  Posted: 'Posted',
  Scheduled: 'Scheduled',
  Draft: 'Draft',
  Failed: 'Failed',
};

export const FilterOptionKeys = {
  Scheduled: 'scheduled',
  Posted: 'posted',
  Failed: 'failed',
  Draft: 'draft',
};

export const MediaContainer = {
  McaSocial: 'McaSocial',
  McaAds: 'McaAds',
};

export const PerformanceChartTypes = {
  Platform: 'platform',
  Metrics: 'metrics',
};

export const PlatformPerfChartMetricTypes = {
  Audience: 'Audience',
  Social: 'Social',
  Search: 'Search',
  SearchAndSocial: 'SearchSocial',
  All: 'All',
};

export const ReplyType = {
  private: {
    id: 'private',
    value: _TL_('Private Message'),
  },
  public: {
    id: 'public',
    value: _TL_('Public response'),
  },
};

export const ReplyState = {
  Edit: 'Edit',
  Sending: 'Sending',
  Successful: 'Successful',
  Failed: 'Failed',
};

export const ChannelSubMetrics = {
  Reactions: {
    id: 'Reactions',
    title: _TL_('Reactions'),
  },
  Comments: {
    id: 'Comments',
    title: _TL_('Comments'),
  },
  Shares: {
    id: 'Shares',
    title: _TL_('Shares'),
  },
  Likes: {
    id: 'Likes',
    title: _TL_('Likes'),
  },
  Replies: {
    // MT returns Replies metric as Comments,
    // hence using Comments metric id for lookup.
    id: 'Comments',
    title: _TL_('Replies'),
  },
  Retweets: {
    // MT returns Retweets metric as Shares,
    // hence using Shares metric id for lookup.
    id: 'Shares',
    title: _TL_('Retweets'),
  },
  AudiencesGain: {
    id: 'AudiencesGain',
    title: _TL_('Fans gained'),
  },
  AudiencesLost: {
    id: 'AudiencesLost',
    title: _TL_('Fans lost'),
  },
  FollowersGain: {
    id: 'AudiencesGain',
    title: _TL_('Followers gained'),
  },
  FollowersLost: {
    id: 'AudiencesLost',
    title: _TL_('Followers lost'),
  },
};

export const DataStates = {
  Initializing: 'Initializing',
  Loading: 'Loading',
  Error: 'Error',
  Successful: 'Successful',
};

export const AdType = {
  SearchAd: 'SearchAd',
  ImageAd: 'ImageAd',
  VideoAd: 'VideoAd',
  CarouselAd: 'CarouselAd',
};

// Microsoft.Ads.Mca.BusinessMT.Model.Ads.ImageSource
export const ImageSource = {
  UserUpload: 'UserUpload',
  ParseFromUrl: 'ParseFromUrl',
  Template: 'Template',
  M365Getty: 'M365Getty',
  StaticImage: 'StaticImage',
};

export const TOP_ADS_PIVOT_ID = 'TopAd';
export const AdPivots = [{
  id: TOP_ADS_PIVOT_ID,
  name: _TL_('Top ads'),
  shouldShowIfEmpty: true,
}, {
  id: AdType.SearchAd,
  name: _TL_('Text ads'),
  type: AdType.SearchAd,
}, {
  id: AdType.ImageAd,
  name: _TL_('Image ads'),
  type: AdType.ImageAd,
}, {
  id: AdType.VideoAd,
  name: _TL_('Video ads'),
  type: AdType.VideoAd,
}];

export const urlPrefixOptions = [
  { key: 'https', text: 'https://' },
  { key: 'http', text: 'http://' },
];

export const urlHost = {
  Facebook: 'facebook',
  Instagram: 'instagram',
};

export const ActivityTypeDialogText = {
  FacebookWallPost: _TL_('wall post'),
  FacebookComment: _TL_('comment'),
  FacebookAdComment: _TL_('ad comment'),
  FacebookReview: _TL_('review'),
  FacebookPost: _TL_('Facebook post'),

  InstagramComment: _TL_('comment'),
  InstagramAdComment: _TL_('comment'),
  InstagramPost: _TL_('Instagram post'),

  TwitterPost: _TL_('Twitter post'),
  TwitterMention: _TL_('tweet'),
  TwitterRetweet: _TL_('tweet'),
  TwitterRetweetWithComment: _TL_('comment'),
  TwitterNewFollower: _TL_('notification'),

  LinkedInComment: _TL_('comment'),
  LinkedInShare: _TL_('LinkedIn share'),

  GoogleMyBusinessReview: _TL_('review'),
  GoogleMyBusinessQuestion: _TL_('question'),
  BingPlacesReview: _TL_('review'),
};

export const wideChartWidth = 996;
export const narrowChartWidth = 466;

export const supportLink = 'https://help.digitalmarketing.microsoft.com/#apex/27/en/30006';
export const helpLink = 'https://help.digitalmarketing.microsoft.com/';
export const privacyAndCookiesLink = 'https://privacy.microsoft.com/en-us/PrivacyStatement';
export const subscriptionTnCLink = 'https://about.ads.microsoft.com/en-us/resources/policies/subscription-ads-beta';
export const subscriptionTnCLearnMoreLink = 'https://aka.ms/AAhkymq';
// TODO: update the link
export const learnMoreCreateCampaignLink = 'https://www.bing.com';
export const learnMoreConnectSocialMediaLink = 'https://www.bing.com';

export const acceptableImageTypes = [
  '.png',
  '.jpg',
  '.jpeg',
  '.jfif',
  '.gif',
];

export const acceptableVideoTypes = [
  '.mp4',
  '.wmv',
  '.mov',
  '.gif',
];

export const MediaTypeMap = {
  '.png': MediaType.Image,
  '.jpg': MediaType.Image,
  '.jpeg': MediaType.Image,
  '.jfif': MediaType.Image,
  '.gif': MediaType.Image, // gif is treated as Image type by social channels
  '.mp4': MediaType.Video,
  '.wmv': MediaType.Video,
  '.mov': MediaType.Video,
};

export const FileSizeLimits = {
  Image: 30 * 1024 * 1024,
  Gif: 15 * 1024 * 1024,
  Video: 1 * 1024 * 1024 * 1024,
};

export const OrganicPostsMetrics = {
  Post: 'Posts',
  Engagements: 'Engagements',
  Likes: 'Likes',
  Impressions: 'Impressions',
  Published: 'Published',
};

export const allCampaignMetrics = [
  'Impressions',
  'Clicks',
  'Directions',
  'Calls',
  'Conversions',
  'Spend',
  'Engagements',
];

export const adsAndSocialMetrics = [
  'Impressions',
  'Clicks',
  'Conversions',
  'Spend',
  'Engagements',
];

export const NEW_ACTIVITY_DATE_RANGE_OFFSET = 30;

export const ConversionTrackingHelpIds = {
  metricsOverall: 'pop_DMC_Campaigns_CATMetricsTile_CAT ',
  metricsVisits: 'pop_DMC_Campaigns_CATMetricsTile_TotalVisits',
  metricsVisitRate: 'pop_DMC_Campaigns_CATMetricsTile_RateOfVisits',
  metricsAssists: 'pop_DMC_Campaigns_CATMetricsTile_TotalAssists',
  metricsTopPageVisits: 'pop_DMC_Campaigns_CATMetricsTile_TopPageVisits',
  metricsAvgTime: 'pop_DMC_Campaigns_CATMetricsTile_AvgTime',
  metricsAvgPages: 'pop_DMC_Campaigns_CATMetricsTile_AvgPages',
  metricsTotalVisits: 'pop_DMC_Campaigns_CATMetricsTile_TotalVisitors',
  metricsTotalConversions: 'pop_BA_UET_Conversions',
  metricsConversionRate: 'pop_BA_CampaignGrids_ConvRate',
  metricsTotalRevenue: 'pop_BA_UET_Revenue',
  metricsEstRevenue: 'pop_BA_TotalEstConversionRev',
  specialPagesPanelTracking: 'pop_DMC_Campaigns_CAT_SpecialPagesPanel_Tracking',
  specialPagesPanelName: 'pop_DMC_Campaigns_CAT_SpecialPagesPanel_PageName',
  specialPagesPanelQualifier: 'pop_DMC_Campaigns_CAT_SpecialPagesPanel_Qualifier',
  specialPagesPanelUrl: 'pop_DMC_Campaigns_CAT_SpecialPagesPanel_URL',
  specialPagesPageTypes: 'pop_DMC_Campaigns_CATWiz_SpecialPages_PageTypes',
  specialPagesName: 'pop_DMC_Campaigns_CATWiz_SpecialPages_PageName',
  specialPagesQualifier: 'pop_DMC_Campaigns_CATWiz_SpecialPages_Qualifier',
  specialPagesUrl: 'pop_DMC_Campaigns_CATWiz_SpecialPages_URL',
  specialPagesLearnMore: 'app30016',
  specialPagesTotalConversions: 'pop_BA_UET_Conversions',
  goalTypes: 'pop_BA_UET_GoalTypes',
  goalCategories: 'pop_BA_ConversionGoal_GoalCategory',
  goalTrackingStatus: 'pop_BA_UET_TrackingStatus',
  goalTagInstruction: 'pop_BA_UET_TagInstruction',
  customEventParametersLearnMore: 'app54597',
  revenueValue: 'pop_BA_UET_RevenueValue',
  revenueVariantValueLearnMore: 'app51210',
  tile: {
    Container: 'app30010',
    DMC: 'app30010',
    UET: 'app54732',
  },
  emailTag: {
    Container: 'app30017',
    DMC: 'app30017',
    UET: 'app54733',
  },
  emailPlatform: {
    Container: {
      Wordpress: 'app30014',
      Wix: 'app30013',
      Shopify: 'app30012',
      BigCommerce: 'app30011',
    },
    DMC: {
      Wordpress: 'app30014',
      Wix: 'app30013',
      Shopify: 'app30012',
      BigCommerce: 'app30011',
    },
    UET: {
      Wordpress: 'app54735',
      Wix: 'app54736',
      Shopify: 'app54737',
      BigCommerce: 'app54738',
    },
  },
};

export const ConversionTrackingHelpIdsUp = {
  ...ConversionTrackingHelpIds,
  specialPagesLearnMore: 'app54780',
  tile: {
    Container: 'app54778',
    DMC: 'app54778',
    UET: 'app54732',
  },
  emailTag: {
    Container: 'app54753',
    DMC: 'app54753',
    UET: 'app54733',
  },
  allPlatformsLearnMore: 'https://help.ads.microsoft.com/#apex/ads/en/60088/-1-500',
};

export const WizardSubmitType = {
  None: 0,
  Submit: 1,
  Skip: 2,
  SwitchToExpertMode: 3,
  SwitchToOldSmartMode: 4,
};

export const UrlValidationStatus = {
  Pass: 'Pass',
  Timeout: 'Timeout',
  BlockedByThirdParty: 'BlockedByThirdParty',
  Fail: 'Fail',
  ServerError: 'ServerError',
  None: 'None',
};

export const UrlErrorCodes = {
  BlockedByCloudflare: 'BlockedByCloudflare',
  UrlScanFailed: 'UrlScanFailed',
  UrlSSLVerificationFailed: 'UrlSSLVerificationFailed',
};
export const UI_TRACE_WAIT_IN_MS = 1000;

export const UpCampaignGoals = {
  IncreaseWebsiteVisit: {
    value: 'IncreaseWebsiteVisit',
    title: _TL_('Visits to my website'),
    isRecommended: true,
  },
  IncreaseCallToBusiness: {
    value: 'IncreaseCallToBusiness',
    title: _TL_('Phone calls to my business'),
    isRecommended: false,
  },
  IncreaseBusinessLocationVisit: {
    value: 'IncreaseBusinessLocationVisit',
    title: _TL_('Visits to my physical business locations'),
    isRecommended: false,
  },
};

export const SELECTED_ACTIVITY_TYPES = [
  'FacebookPost',
  'InstagramPost',
  'TwitterPost',
  'LinkedInShare',
];

export const ACTIVITIES_FILTER = _.chain(SELECTED_ACTIVITY_TYPES)
  .map(type => `ActivityType eq Enum.ActivityType'${type}'`)
  .join(' or ')
  .value();

export const NotSetBusinessSize = 'Unknown';
export const DefaultBusinessSizeOption = 'OnlyOne';

export const BusinessSizeOptions = [
  {
    key: 'OnlyOne',
    text: _TL_('1'),
  },
  {
    key: 'TwoAndFour',
    text: _TL_('2 - 4'),
  },
  {
    key: 'FiveAndNine',
    text: _TL_('5 - 9'),
  },
  {
    key: 'TenAndTwentyFour',
    text: _TL_('10 - 24'),
  },
  {
    key: 'TwentyFiveAndFourtyNine',
    text: _TL_('25 - 49'),
  },
  {
    key: 'FiftyAndNinetyNine',
    text: _TL_('50 - 99'),
  },
  {
    key: 'HundredAndHundredFourtyNine',
    text: _TL_('100 - 149'),
  },
  {
    key: 'HundredFiftyAndTwoHundredFourtyNine',
    text: _TL_('150 - 249'),
  },
  {
    key: 'TwoHundredFiftyAndTwoHundredNinetyNine',
    text: _TL_('250 - 299'),
  },
  {
    key: 'ThreeHundredAndFourHundredNinetyNine',
    text: _TL_('300 - 499'),
  },
  {
    key: 'FiveHundredAndNineHundredNinetyNine',
    text: _TL_('500 - 999'),
  },
  {
    key: 'GreaterThanOneThousand',
    text: _TL_('>= 1000'),
  },
];

// Note: only support English for now
export const LanguageOptions = [
  {
    key: 'en-us',
    text: _TL_('English (US)'),
  },
];

export const AddressFieldsForCcForm = [
  'City',
  'Country',
  'Line1',
  'Line2',
  'PostalCode',
  'StateOrProvince',
];

export const ScrollToTypes = {
  Ads: 'Ads',
  KeywordThemes: 'KeywordThemes',
  CampaignDetails: 'CampaignDetails',
  Targets: 'Targets',
};

export const SpecialAdCategoryTypes = {
  None: 'None',
  Employment: 'Employment',
  Housing: 'Housing',
  Credit: 'Credit',
  IssuesElectionsPolitics: 'IssuesElectionsPolitics',
};

export const TermsAndConditionLink = {
  // visit https://about.ads.microsoft.com/en-us/resources/policies/microsoft-advertising-agreement?msatoolbar=1 to see all the supported languages
  'de-de': 'https://about.ads.microsoft.com/de-de/ressourcen/richtlinien/microsoft-advertising-vertrag',
  'en-us': 'https://about.ads.microsoft.com/en-us/resources/policies/microsoft-advertising-agreement',
  'es-es': 'https://about.ads.microsoft.com/es-es/recursos/directivas/contrato-de-microsoft-advertising',
  'fr-fr': 'https://about.ads.microsoft.com/fr-fr/ressources/politiques/contrat-microsoft-advertising',
  'it-it': 'https://about.ads.microsoft.com/it-it/risorse/informative/contratto-per-microsoft-advertising',
  'pt-br': 'https://about.ads.microsoft.com/pt-br/recursos/politicas/contrato-do-microsoft-advertising',
  'zh-tw': 'https://about.ads.microsoft.com/zh-tw/resources/policies/microsoft-advertising-agreement',
};

export const Products = {
  Expert: 'Expert',
  Smart: 'Smart',
  DMC: 'DMC',
  UP: 'UP',
  Unknown: 'Unknown',
};

export const McaLocationType = {
  Country: 'Country',
  SubGeography: 'SubGeography',
  MetroArea: 'MetroArea',
  City: 'City',
  PostalCode: 'PostalCode',
  County: 'County',
  Neighborhood: 'Neighborhood',
};

export const AppScope = {
  ADV: 1,
  DMC: 8,
};

export const UpSignupWizardCouponClassForProd = 'AENOTINCPBCOFY22US100'; // for product

export const UpSignupWizardCouponClassForNonProd = 'ATESTCOUPONCLASSXIAOHUL01'; // for non-product

export const UpSignupWizardCouponDetails = {
  // for product
  AENOTINCPBCOFY22US100: {
    ClassName: 'AENOTINCPBCOFY22US100',
    CouponPurposeId: 0,
    CouponTypeId: 3,
    CouponValue: 100,
    CurrencyId: 12,
    EndDate: '2023-12-31T00:00:00.0000000',
    ExpiryDate: '2023-12-31T00:00:00.0000000',
    ExpiryDateFromAssociation: '0001-01-01T00:00:00.0000000',
    LimitForDaysToUseFromCustomerCreation: 30,
    MaxRedemptionCount: 1,
    MaxRedemptionPerAccountCount: 1,
    PercentOff: null,
    StartDate: '2021-12-01T00:00:00.0000000',
    UpfrontSpending: 25,
    id: 112758,
  },
  // for non-product
  ATESTCOUPONCLASSXIAOHUL01: {
    ClassName: 'ATESTCOUPONCLASSXIAOHUL01',
    CouponPurposeId: 0,
    CouponTypeId: 3,
    CouponValue: 100,
    CurrencyId: 12,
    EndDate: '2026-08-01T00:00:00.0000000',
    ExpiryDate: '2026-08-01T00:00:00.0000000',
    ExpiryDateFromAssociation: '0001-01-01T00:00:00.0000000',
    LimitForDaysToUseFromCustomerCreation: 30,
    MaxRedemptionCount: 1,
    MaxRedemptionPerAccountCount: 1,
    PercentOff: null,
    StartDate: '2023-11-01T00:00:00.0000000',
    UpfrontSpending: 25,
    id: 1243216625,
  },
};

// Below coupons will get removed when user switches to Expert from ESC
// and get appended when switching back
export const ESC_ONLY_COUPONS = [
  UpSignupWizardCouponClassForProd,
  UpSignupWizardCouponClassForNonProd,
  'AENOTINCBINGFY22US150', // BNP promotion CCL
  'AENOTINCBINGFY23US150', // BNP promotion CCL in FY23
];

export const DAYS_OF_MONTH = 30.4; // 30.4 days on average

export const SubscriptionPlanType = {
  Standard: 'Standard',
  Basic: 'Basic',
  Premium: 'Premium',
  Custom: 'Custom',
};

export const SubscriptionPlanTypeLocal = {
  Standard: _TL_('Standard'),
  Basic: _TL_('Basic'),
  Premium: _TL_('Premium'),
  Custom: _TL_('Custom'),
};

export const SubscriptionPlanStatus = {
  Active: 'Active',
  Cancelled: 'Cancelled',
  Deleted: 'Deleted',
  Draft: 'Draft',
};

export const McaChannelMinBudgetPerDay = {
  [McaChannelTypes.Facebook]: 5,
  [McaChannelTypes.GoogleAds]: 3,
  [McaChannelTypes.MicrosoftAdvertising]: 2,
};

export const PerfType = {
  Clicks: 'Clicks',
  Conversions: 'Conversions',
};

export const EscLegalBusinessCountries = ['US', 'CN'];

// Sub ads phase2 only support website goal
export const SUB_ADS_DEFAULT_CAMPAIGN_GOAL_OPTIONS = {
  IncreaseWebsiteVisit: true,
  IncreaseCallToBusiness: false,
  IncreaseBusinessLocationVisit: false,
};

// 600px
export const mobileMaxWidth = 600;
export const mobileDeviceQuery = `(max-width:${mobileMaxWidth}px)`;
export const mobileDevice = `@media ${mobileDeviceQuery}`;

export const tabletMaxWidth = 768;
export const tabletDeviceQuery = `(max-width:${tabletMaxWidth}px)`;
export const tabletDevice = `@media ${tabletDeviceQuery}`;

export const WebsiteValidationStatus = {
  Valid: 'Valid',
  URLNotValid: 'URLNotValid',
  URLAdvertisedBefore: 'URLAdvertisedBefore',
  MTError: 'MTError', // only used in UI
};

export const EscImageRequirements = {
  maxFileSize: 30 * 1024 * 1024,
  minWidth: 720,
  minHeight: 720,
};

export const MsanImageRequirements = {
  maxFileSize: 5 * 1024 * 1024,
  minWidth: 720,
  minHeight: 720,
  maxWidth: 2048,
  maxHeight: 2592,
};
